/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ResocontoPastiStudenti } from './resoconto-pasti-studenti';
import { ResocontoPastiDipendenti } from './resoconto-pasti-dipendenti';


export interface ServizioMensaReportMensileDTO { 
    mese?: string;
    label?: string;
    scuole_dipendenti?: Array<ResocontoPastiDipendenti>;
    scuole_studenti?: Array<ResocontoPastiStudenti>;
}

